import React, { useState, useEffect } from 'react';
import { Bot, Sparkles } from 'lucide-react';

/**
 * AI가 답변을 생성 중일 때 보여주는 프리미엄 타이핑 인디케이터 컴포넌트.
 */
const ChatTypingIndicator = () => {
    const [statusIndex, setStatusIndex] = useState(0);
    const statuses = [
        "관련 법령 조문을 분석하고 있습니다...",
        "적절한 규제 답변을 구성 중입니다...",
        "거의 다 되었습니다. 잠시만 기다려주세요..."
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setStatusIndex((prev) => (prev + 1) % statuses.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [statuses.length]);

    return (
        <div className="flex gap-3 items-end animate-fade-in-up py-1 flex-none self-start h-auto">
            {/* 봇 아이콘 영역 */}
            <div 
                className="relative rounded-2xl bg-gray-800 text-white flex items-center justify-center shadow-sm flex-shrink-0"
                style={{ width: '36px', height: '36px' }}
            >
                <Bot size={18} className="relative z-10" />
            </div>

            {/* 인라인 타이핑 버블 (강제 높이 고정으로 쫙 늘어나는 현상 방지) */}
            <div className="bg-white border border-gray-100 px-3.5 py-2.5 rounded-2xl rounded-tl-sm flex gap-2.5 items-center w-fit shadow-sm flex-none h-auto min-h-[36px]">
                {/* 깜빡이는 점 3개 */}
                <div className="flex gap-1 items-center bg-blue-50/70 px-2 py-1.5 rounded-full flex-none">
                    <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                    <span className="w-1.5 h-1.5 bg-blue-500/80 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                    <span className="w-1.5 h-1.5 bg-blue-500/40 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
                </div>
                
                {/* 구분선 (세로로 길어지지 않게 고정 높이 지정) */}
                <div className="w-[1px] bg-gray-200 flex-none" style={{ height: '14px' }}></div>

                {/* 상태 메시지 */}
                <div className="flex items-center gap-1.5 pr-1 flex-none">
                    <Sparkles size={12} className="text-blue-500 animate-pulse-soft" />
                    <span className="text-[12.5px] text-gray-600 font-medium tracking-tight whitespace-nowrap">
                        {statuses[statusIndex]}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ChatTypingIndicator;
